/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { withTheme } from '@material-ui/core';
import { hotjar } from 'react-hotjar';
import config from '../config';

// #Source https://bit.ly/2neWfJ2
const parseCookie = str =>
    str
        .split(';')
        .map(v => v.split('='))
        .reduce((acc, v) => {
            if (v.length !== 2) {
                return acc;
            }
            acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
            return acc;
        }, {});

function injectDoneCookieTool(policy_url, color, cookieGroups) {
    window.DONEGDPRParams = {
        lang: 'en',
        policy_url,
        color,
        groups: cookieGroups
    };

    const jsUrl = 'https://cdn.thisisdone.com/gdpr/1.3.latest/cookie.min.js';
    if (!document.querySelector(`script[src*="${jsUrl}"]`)) {
        const a = document.getElementsByTagName('head')[0];
        const r = document.createElement('script');
        r.async = 1;
        r.src = jsUrl;
        a.appendChild(r);
    }
}

function injectPendoIo() {
    // fix for double inserting
    if (window.pendoinited) {
        return;
    }
    window.pendoinited = true;
    (function(apiKey) {
        (function(p, e, n, d, o) {
            let v;
            let w;
            let x;
            let y;
            let z;
            o = p[d] = p[d] || {};
            o._q = [];
            v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
            for (w = 0, x = v.length; w < x; ++w) {
                (function(m) {
                    o[m] =
                        o[m] ||
                        function() {
                            o._q[m === v[0] ? 'unshift' : 'push'](
                                [m].concat([].slice.call(arguments, 0))
                            );
                        };
                })(v[w]);
            }
            y = e.createElement(n);
            y.async = !0;
            y.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
            z = e.getElementsByTagName(n)[0];
            z.parentNode.insertBefore(y, z);
        })(window, document, 'script', 'pendo');
    })('59e6aa40-48f0-4d4b-5ed3-cb3135156ab3');
}

function injectGoogleAnalytics() {
    // fix for double inserting
    if (window.analyticsinited) {
        return;
    }
    window.analyticsinited = true;

    (function(i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r;
        i[r] =
            i[r] ||
            function() {
                (i[r].q = i[r].q || []).push(arguments);
            };

        i[r].l = 1 * new Date();
        a = s.createElement(o);
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    window.ga('create', 'UA-68379734-1', 'auto');
    window.ga('send', 'pageview');
}

const CookieBar = ({ clientData, theme }) => {
    // local storage change listener for cookie tool
    const [concent, setConcet] = useState({});
    useEffect(() => {
        if (Object.keys(concent).length > 0) {
            return;
        }
        let checker = null;
        function checkCookie() {
            const cookies = parseCookie(document.cookie);
            if (cookies && cookies.DONEGDPRConsent) {
                try {
                    setConcet(JSON.parse(cookies.DONEGDPRConsent));
                } catch (err) {
                    // nothing
                }
                clearInterval(checker);
                return true;
            }
            return false;
        }
        if (checkCookie()) {
            return;
        }
        checker = setInterval(checkCookie, 500);
        return () => {
            clearInterval(checker);
        };
    }, [concent, setConcet]);

    injectDoneCookieTool(`${config.assetsUrl}/termsandconditions.pdf`, theme.palette.primary.main, {
        always_active: [{ name: 'Page Cookie Consent' }],
        performance: [{ name: 'Google Analytics' }],
        functional: [{ name: 'Pendo.io' }, { name: 'Hotjar' }],
        targeting: [{ name: 'Google Analytics' }]
    });

    // handle cookie settings
    if (concent && concent.functional === true) {
        injectPendoIo();
    }
    if (concent && concent.functional === true && clientData.hotjarid && clientData.hotjarsv) {
        hotjar.initialize(clientData.hotjarid, clientData.hotjarsv);
    }
    if (concent && (concent.targeting === true || concent.performance === true)) {
        injectGoogleAnalytics();
    }
    return <></>;
};

export default withTheme(CookieBar);
